import React, { useState, useCallback } from 'react';
import { Card, CardBody } from 'reactstrap';
// import EditManagedProductForm from '../EditManagedProductForm';
import ConfirmModal from 'js/components/modal/ConfirmModal';
import ManagedProductForm from '../../ManagedProductForm';
import ProductCapabilitiesList from './ProductCapabilitiesList';

function ManagedProductSettings({
  managedProduct,
  capabilitySets,
  onUpdate = () => {},
  onLinkCapability = () => {},
  onUnlinkCapability = () => {},
  onLinkCapabilities = () => {},
  onUnlinkCapabilities = () => {},
}) {
  const [showArchiveModal, setShowArchiveModal] = useState(false);

  const handleUpdate = useCallback(
    (values) => {
      return onUpdate({ id: managedProduct.id, ...values });
    },
    [managedProduct?.id, onUpdate]
  );

  const handleArchive = () => {
    setShowArchiveModal(true);
  };

  const handleUnarchive = useCallback(() => {
    return onUpdate({ id: managedProduct.id, archived_state: null });
  }, [managedProduct?.id, onUpdate]);

  const handleArchiveModalConfirm = useCallback(async () => {
    await onUpdate({
      id: managedProduct.id,
      archived_state: 'archived',
    });
    setShowArchiveModal(false);
  }, [managedProduct?.id, onUpdate]);

  return !managedProduct ? null : (
    <>
      <Card>
        <CardBody>
          <h5>General</h5>
          <ManagedProductForm
            managedProduct={managedProduct}
            mode="edit"
            onSubmit={handleUpdate}
            onArchive={handleArchive}
            onUnarchive={handleUnarchive}
          />
          <div className="row mt-4">
            <div className="col-12 col-md-6">
              <ProductCapabilitiesList
                managedProduct={managedProduct}
                capabilitySets={capabilitySets}
                onLinkCapability={onLinkCapability}
                onUnlinkCapability={onUnlinkCapability}
                onLinkCapabilities={onLinkCapabilities}
                onUnlinkCapabilities={onUnlinkCapabilities}
              />
            </div>
            <div className="col-12 col-md-6">
              <h5>Teams</h5>
              <p>This product is not associated with any teams.</p>
            </div>
          </div>
        </CardBody>
      </Card>
      <ConfirmModal
        isOpen={showArchiveModal}
        title="Archive managed product?"
        onConfirm={handleArchiveModalConfirm}
        onCancel={() => setShowArchiveModal(false)}
        confirmButtonLabel="Archive"
      >
        <p>
          Please confirm that you want to archive{' '}
          <strong>{managedProduct?.name || 'this managed product'}</strong>.
        </p>
      </ConfirmModal>
    </>
  );
}

export default ManagedProductSettings;
